/*
	Home component shown at home
*/

<template>
	<div>
		<h1 class="red">Home All</h1>
	</div>

</template>


<script>
	export default {

		data () {
			return {
			}
		}
	}
</script>


<style>
	.red {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// HomeView.vue?e0f636c6